import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useActiveTemplateId } from './use-active-project-template';
const getProjectTemplateTask = ()=>createSelector((state)=>state.templates.project.data, (_, { taskId, templateId })=>({
            taskId,
            templateId
        }), (data, { taskId, templateId })=>data[templateId].tasks[taskId]);
export const useProjectTemplateTask = (taskId)=>{
    const templateId = useActiveTemplateId();
    const taskObject = useMemo(getProjectTemplateTask, []);
    return useSelector((state)=>{
        return taskObject(state, {
            taskId,
            templateId
        });
    });
};
